import { EditorEvent } from '../../editor/types';
import type { PendingEvents } from '../../events/pending';

export abstract class ImageEvents extends EditorEvent {
  protected constructor(type: string) {
    super('ImagePlugin', type);
  }
}

export class ImageSizeExceeded extends ImageEvents {
  constructor() {
    super('upload size exceeded');
  }
}

export class ImageUploadError extends ImageEvents {
  constructor(message: string) {
    super(message);
  }
}

export type ImagePluginEvent = PendingEvents | ImageEvents;
